import {
  ArrowDown24,
  DataViewAlt24,
  DocumentUnknown24,
  Download24,
} from "@carbon/icons-react";
import { Search32 } from "@carbon/icons-react";
import { Form, Loading } from "carbon-components-react";
import {
  Row,
  Column,
  TextInput,
  Button,
  DataTable,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarContent,
} from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Card from "../../components/Card/Card";
import TablePagination from "../../components/Pagination/Pagination";
import http from "../../http-common";
import { tree } from "d3";
import * as XLSX from "xlsx";

const tableHeaders = [
  {
    header: "Nome",
    key: "name",
  },
  {
    header: "NUIT",
    key: "nuit",
  },
  {
    header: "# de Pontuações Técnicas",
    key: "technicalScoreCount",
  },
  {
    header: "Avaliação Técnica",
    key: "technicalScore",
  },
  {
    header: "Avaliação Administrativa",
    key: "administrativeScore",
  },
  {
    header: "Avaliação Total",
    key: "totalScore",
  },
  {
    header: " ",
    key: "actions",
  },
];

const LinkList = ({ url1, url2, isOpen }) => (
  <ul style={{ display: "flex" }}>
    <li className="mr-1">
      <Link to={url1} title="Consultar Candidatura">
        <DataViewAlt24 />
      </Link>
    </li>
    {/* <li>
      <Link to={url2} title="Consultar Questionário">
        <DocumentUnknown24 />
      </Link>
    </li> */}
  </ul>
);

const getCellContent = (cell, id) => {
  if (cell.info.header === "actions") {
    return (
      <LinkList
        url1={"../candidature/" + id}
        url2={"../self-knowledge-questionnaire/" + id}
      />
    );
  }

  if (
    cell.info.header === "technicalScore" ||
    cell.info.header === "administrativeScore"
  ) {
    // Display the value as is - it's already processed in getApplicationData
    return cell.value;
  }

  return cell.value;
};

const RankingCandidaturesPage = () => {
  const [candidatures, setCandidatures] = useState([]);
  const [count, setCount] = useState(0);
  const [size, setSize] = useState(20);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const featchData = async () => {
    try {
      const response = await http.get("/applications/score-summary");
      getApplicationData(response);
    } catch (error) {}
  };
  const onPageChange = async ({ page, pageSize }) => {
    // Note: The score-summary endpoint returns a single list, not paginated
    // This function is kept for compatibility but may need backend support for pagination
    setSize(pageSize);
    featchData();
  };

  const onSearch = async (data) => {
    // Note: The score-summary endpoint returns a single list, not searchable
    // This function is kept for compatibility but may need backend support for search
    featchData();
  };

  const getApplicationData = (response) => {
    // console.log(response.data);
    // Handle single list response instead of paged response
    const data = response.data.map((c) => ({
      id: c.uuid,
      name: c.companyName,
      nuit: c.nuit,
      responsibleName: c.responsibleName || c.contactPerson || "-",
      province: c.provinceName || c.province || "-",
      technicalScoreCount: c.technicalScoreCount || 0,
      technicalScore:
        c.technicalScore === null || c.technicalScore === undefined
          ? "Não Pontuada"
          : typeof c.technicalScore === "number"
          ? c.technicalScore.toFixed(2)
          : c.technicalScore,
      administrativeScore:
        c.administrativeScore === null || c.administrativeScore === undefined
          ? "Não Pontuada"
          : typeof c.administrativeScore === "number"
          ? c.administrativeScore.toFixed(2)
          : c.administrativeScore,
      totalScore:
        c.totalScore === null || c.totalScore === undefined
          ? "Não Pontuada"
          : typeof c.totalScore === "number"
          ? c.totalScore.toFixed(2)
          : c.totalScore,
    }));
    setCandidatures(data);
    setCount(data.length);
    setIsLoading(false);
  };

  const downloadExcel = () => {
    // Prepare data for Excel export with the specified column headers
    const excelData = candidatures.map((candidature) => ({
      "Nome da Empresa": candidature.name,
      NUIT: candidature.nuit,
      "Nome do Responsável": candidature.responsibleName,
      Província: candidature.province,
      "Número de Pontuações Técnicas": candidature.technicalScoreCount,
      "Pontuação Técnica (PT)": candidature.technicalScore,
      "Pontuação Administrativa (PA)": candidature.administrativeScore,
      "Pontuação Total": candidature.totalScore,
    }));

    // Create workbook and worksheet
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Ranking Candidaturas");

    // Generate filename with current date
    const currentDate = new Date().toISOString().split("T")[0];
    const filename = `ranking-candidaturas-${currentDate}.xlsx`;

    // Download the file
    XLSX.writeFile(wb, filename);
  };

  useEffect(() => {
    featchData();
  }, []);

  return (
    <Card title="Ranking de Candidaturas">
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />

      <DataTable
        rows={candidatures}
        headers={tableHeaders}
        isSortable
        useZebraStyles
      >
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            <TableToolbar aria-label="data table toolbar">
              <TableToolbarContent>
                <Form
                  className="data-table-search-form"
                  onSubmit={handleSubmit(onSearch)}
                >
                  <Row>
                    <Column sm={6} md={8} lg={8}>
                      <TextInput
                        id="name"
                        labelText=""
                        placeholder="Nome"
                        {...register("name")}
                      />
                    </Column>

                    {/* <Column sm={6} md={3} lg={3}>
                      <TextInput
                        id="phoneNumber"
                        labelText=""
                        placeholder="Telefone"
                        {...register("phoneNumber")}
                      />
                    </Column> */}
                  </Row>
                  <Button type="submit" renderIcon={Search32}>
                    Pesquisar
                  </Button>
                </Form>
                <Button
                  kind="secondary"
                  renderIcon={Download24}
                  onClick={downloadExcel}
                  disabled={candidatures.length === 0}
                >
                  Exportar Excel
                </Button>
              </TableToolbarContent>
            </TableToolbar>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {getCellContent(cell, row.id)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
    </Card>
  );
};

export default RankingCandidaturesPage;
